import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import FormPageLayout from 'components/shared/FormPageLayout/FormPageLayout';

export type ClientFormPageProps = {
  /** Page title — defaults based on isEdit */
  title?: string;
  /** Optional subtitle */
  subtitle?: string;
  /** True when editing an existing client */
  isEdit?: boolean;
  /** Label for the primary CTA button */
  primaryLabel?: string;
  /** Called when the primary button is clicked */
  onSubmit?: () => void;
  /** Whether the primary button is in a loading/disabled state */
  submitting?: boolean;
  /** Disable the primary CTA (e.g. form not valid yet) */
  primaryDisabled?: boolean;
  /** Form fields / content — provided by the consumer */
  children?: ReactNode;
};

const ClientFormPage = ({
  title,
  subtitle,
  isEdit = false,
  primaryLabel,
  onSubmit,
  submitting = false,
  primaryDisabled = false,
  children,
}: ClientFormPageProps) => {
  const navigate = useNavigate();

  const resolvedLabel = primaryLabel ?? (isEdit ? 'Save Changes' : 'Create Client');

  return (
    <FormPageLayout
      onDiscardConfirm={() => navigate(-1)}
      primaryAction={{
        label: resolvedLabel,
        onClick: onSubmit ?? (() => {}),
        loading: submitting,
        disabled: submitting || primaryDisabled,
      }}
    >
      {children}
    </FormPageLayout>
  );
};

export default ClientFormPage;
